import { axiosInstance } from "@services/axios";

export const fetchProductQuantityDetails = (params) =>
  axiosInstance.post("/products/inventory_details", params);
